import { createContext, useState, useEffect } from 'react';

export const CelebRegistrationContext = createContext();

export const CelebRegistrationProvider = ({ children }) => {

    const [registrationData, setRegistrationData] = useState(() => {
        try {
            const savedData = sessionStorage.getItem('celebRegistrationData');
            return savedData ? JSON.parse(savedData) : {
                userType: 'celeb',
                fullName: '',
                userPhone: '',
                userPassword: '',
                profilepicture: '',
                email: '',
            };
        } catch (error) {
            console.error('Error loading registration data from sessionStorage:', error);
            return {
                userType: 'celeb',
                fullName: '',
                userPhone: '',
                userPassword: '',
                profilepicture: '',
                email: '',
            };
        }
    });

    useEffect(() => {
        try {
            sessionStorage.setItem('celebRegistrationData', JSON.stringify(registrationData));
        } catch (error) {
            console.error('Error saving registration data to sessionStorage:', error);
        }
    }, [registrationData]);

    const updateRegistrationData = (newData) => {
        setRegistrationData(prev => ({ ...prev, ...newData }));
    };

    const clearRegistrationData = () => {
        setRegistrationData({
            userType: 'celeb',
            fullName: '',
            userPhone: '',
            userPassword: '',
            profilepicture: '',
            email: '',
        });
        try {
            sessionStorage.removeItem('celebRegistrationData');
        } catch (error) {
            console.error('Error clearing registration data from sessionStorage:', error);
        }
    };

    return (
        <CelebRegistrationContext.Provider value={{
            registrationData,
            updateRegistrationData,
            clearRegistrationData
        }}>
            {children}
        </CelebRegistrationContext.Provider>
    );
};